import { render, staticRenderFns } from "./noticeDialog.vue?vue&type=template&id=78875360&scoped=true"
import script from "./noticeDialog.vue?vue&type=script&lang=js"
export * from "./noticeDialog.vue?vue&type=script&lang=js"
import style0 from "./noticeDialog.vue?vue&type=style&index=0&id=78875360&prod&lang=scss&scoped=true"
import style1 from "./noticeDialog.vue?vue&type=style&index=1&id=78875360&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78875360",
  null
  
)

export default component.exports